package com.karawek.core.ui.components

import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.karawek.core.ui.theme.CoreAlphas
import com.karawek.core.ui.theme.CoreTheme
import com.karawek.core.ui.theme.CoreTypography

@Composable
fun CoreTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    placeholder: String = "",
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    error: String? = null,
) {
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        label = { Text(label) },
        placeholder = { Text(placeholder) },
        modifier = modifier,
        enabled = enabled,
        isError = error != null,
        textStyle = CoreTypography.body,
        supportingText = {
            error?.let {
                Text(
                    text = it,
                    style = CoreTypography.caption,
                    color = CoreTheme.colors.error,
                )
            }
        },
        colors = androidx.compose.material3.OutlinedTextFieldDefaults.colors(
            focusedBorderColor = CoreTheme.colors.primary,
            focusedLabelColor = CoreTheme.colors.primary,
            errorBorderColor = CoreTheme.colors.error,
            errorLabelColor = CoreTheme.colors.error,
            disabledBorderColor = CoreTheme.colors.divider.copy(alpha = CoreAlphas.Disabled),
            disabledLabelColor = CoreTheme.colors.textSecondary.copy(alpha = CoreAlphas.Disabled),
        ),
    )
}
